import useAuthUser from './useAuthUser';
import {UserRoleName} from '$modules/admin/constant';
import toast from '$utils/toast';
import {ToastType} from '$components/Toast/constant';

function useUserRole() {
  const user = useAuthUser();
  const role = user?.roleName;

  const validRoles = Object.values(UserRoleName);
  const isValidRole = role && validRoles.includes(role as UserRoleName);

  if (role && !isValidRole) {
    console.warn(`Invalid user role received: "${role}"`);
    toast(
      ToastType.Error,
      'Invalid Role',
      'Invalid user role detected. Please contact the administrator.'
    );
  }

  const safeRole = isValidRole ? (role as UserRoleName) : undefined;
  return {
    role: safeRole,
    isAdmin: role === UserRoleName.Admin,
    isDoctor: role === UserRoleName.Doctor,
    isFrontdesk: role === UserRoleName.Frontdesk,
    isFinance: role === UserRoleName.Finance,
    isPatient: role === UserRoleName.Patient,
    isValidRole,
    isUnknownRole: !isValidRole,
  };
}

export default useUserRole;
